<template>
  <div class="card">
    <div class="card-body pt-3 p-3">
      <ul class="list-group">
        <li v-for="(persona, index) in afiliados" :key="index" class="list-group-item border-0 d-flex p-4 mb-2 mt-3 bg-gray-100 border-radius-lg">
          <div class="d-flex flex-column">
            <h6 class="mb-3 text-sm">
              {{persona.nombres}} {{persona.apellidos}}
            </h6>
            <span class="mb-2 text-xs">
              Documento:
              <span class="text-dark font-weight-bold ms-sm-2">{{ persona.documento }}</span>
            </span>
            <span class="mb-2 text-xs">
              Fecha de Nacimiento:
              <span class="text-dark font-weight-bold ms-sm-2">{{ persona.dob }}</span>
              <span class="text-dark font-weight-bold ms-sm-2">({{ persona.edad }} años)</span>
            </span>
            <span class="mb-2 text-xs">
              Teléfono:
              <span class="text-dark ms-sm-2 font-weight-bold">{{ persona.telefono }}</span>
            </span>
            <span class="mb-2 text-xs">
              Email Address:
              <span class="text-dark ms-sm-2 font-weight-bold">{{ persona.email }}</span>
            </span>
          </div>
          <div class="ms-auto text-end" v-if="this.downloadPDF != ''">
            <a class="btn btn-link text-addiuva text-gradient px-3 mb-0" href="javascript:;" @click="this.downloadPDF(persona.id_afiliado)">
              <i class="fas fa-cloud-download-alt me-2" aria-hidden="true"></i>Descargar Certificado
            </a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
// import authHeader from '../../services/auth-header';
export default {
  name: "detalle-afiliados",
  props: {
    afiliados: {
      type: Array
    }
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
    }
  },
  methods: {
    downloadPDF: function(id_afiliado) {
      // Send Data by Axios
      let url = this.API_URL + "/afiliaciones/certificado";
      axios({
        url: url,
        method: 'post',
        data: { "id_afiliado": id_afiliado },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then(response => {
        if (response.data.status) {
            let documento_certificado = response.data.data.documento_certificado;
            const linkSource = `data:application/pdf;base64,${documento_certificado}`;
            const downloadLink = document.createElement("a");
            const fileName = response.data.data.codigo_certificado + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    }
  }
};
</script>
